import { CanActivateFn } from '@angular/router';
import { SharedService } from '../services/shared-service';
import { inject } from '@angular/core';
import { filter, map, switchMap } from 'rxjs';
import { SubscriptionPlanService } from '../services/subscription-plan.service';

export const PlanDataGuard: CanActivateFn = (route, state) => {
  // Inject the required services
    const planService = inject(SubscriptionPlanService);
    const sharedService = inject(SharedService);
  
    return sharedService.setupComplete$.pipe(
      filter((setupComplete) => setupComplete), // Wait for setupComplete$ to emit true
      switchMap(() => planService.planDataLoaded$), // Check if plan data is loaded
      filter((loaded) => loaded), // Ensure plan data is fully loaded
      map(() => true) // Allow route activation
    );
};
